import apiClient from './api';

export interface NewsItem {
  id: number;
  title: string;
  excerpt: string | null;
  content: string;
  cover_color: string;
  status: 'draft' | 'published';
  author_id: number;
  author_name: string | null;
  created_at: string | null;
  published_at: string | null;
  updated_at: string | null;
}

interface NewsListResponse {
  news: NewsItem[];
  total: number;
}

interface NewsResponse {
  news: NewsItem;
}

export const newsService = {
  async getPublished(limit = 50, offset = 0): Promise<NewsItem[]> {
    const res = await apiClient.get<NewsListResponse>('/api/news/published', {
      params: { limit, offset },
    });
    return res.data.news;
  },

  async getPublishedById(id: number): Promise<NewsItem | null> {
    try {
      const res = await apiClient.get<NewsResponse>(`/api/news/published/${id}`);
      return res.data.news;
    } catch {
      return null;
    }
  },

  async getLatest(count: number): Promise<NewsItem[]> {
    return this.getPublished(count, 0);
  },

  async getAll(): Promise<NewsItem[]> {
    const res = await apiClient.get<NewsListResponse>('/api/news/all');
    return res.data.news;
  },

  async getById(id: number): Promise<NewsItem | null> {
    try {
      const res = await apiClient.get<NewsResponse>(`/api/news/all/${id}`);
      return res.data.news;
    } catch {
      return null;
    }
  },

  async create(data: {
    title: string;
    excerpt?: string;
    content: string;
    cover_color?: string;
    status?: string;
  }): Promise<NewsItem> {
    const res = await apiClient.post<NewsResponse>('/api/news', data);
    return res.data.news;
  },

  async update(id: number, data: Partial<{
    title: string;
    excerpt: string;
    content: string;
    cover_color: string;
    status: string;
  }>): Promise<NewsItem> {
    const res = await apiClient.put<NewsResponse>(`/api/news/${id}`, data);
    return res.data.news;
  },

  async publish(id: number): Promise<NewsItem> {
    const res = await apiClient.post<NewsResponse>(`/api/news/${id}/publish`);
    return res.data.news;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/news/${id}`);
  },
};